export const enum OptionDataType {
    String,
    Integer,
    Boolean,
    GuidArray,
}

export const enum UserPermissionScope {
    Mobile,
    Web
}

export const enum AlertSeverity {
    Error = "error",
    Warning = "warning",
    Info = "info",
    Success = "success",
}

export enum TransportPlanState {
    Todo,
    Planning,
    Planned,
    InTransport,
    Completed
}

export enum TransportOrderInvoicingState {
    NotInvoiceable,
    Invoiceable,
    InvoicedInternally,
    AddedToInvoice,
    InvoicedExternally
}

export enum ParcelTypes {
    EURlava = "EURLava",
    FINlava = "FINLava",
    Teholava = "Teholava",
    Muulava = "Muulava",
    Rullakko = "Rullakko",
    Irtokolli = "Irtokolli",
    IBCkontti = "IBCKontti",
    Häkki = "Häkki",
    Nippu = "Nippu",
    Muu = "Muu",
    Irtoneste = "Irtoneste"
}

export enum HazardousMaterials {
    First,
    Second,
    Third,
    Fourth,
    Fifth
}
export const enum WorkShiftTimeSlotState {
    InProgress,
    Done,
    Locked
}

export const enum DayBookingUsageType {
    FullDay,
    NotFullDay
}

export const enum DayBookingState {
    UnLocked,
    Locked
}

export class EnumHelper {
    static isEqual(i: number, e: WorkShiftTimeSlotState): boolean {
        return i > e - 0.5 && i < e + 0.5;
    }
}


export const enum StrMeasureUnit {
    Hour = "h",
    HourFi = "t",
    Piece = "kpl",
    Day = "pv",
    DayFiAlt = "p",
    DayEn = "d",
}
